(function () {
    'use strict'

    angular.module('app').controller('changePasswordController', changePasswordController);
    changePasswordController.$inject = ["$http", "urlHelper", "$sessionStorage", "userService"];

    function changePasswordController($http, urlHelper, $sessionStorage, userService) {
        var vm = this;
        vm.email = "";
        vm.currentPwd = "";
        vm.newPwd = "";
        vm.confirmPwd = "";
        vm.showCurrentPwd = false;
        vm.showNewPwd = false;
        vm.showConfirmPwd = false;
        vm.success = false;
        vm.error = false;
        vm.passwordsDontMatch = false;
        vm.validated = false;
        vm.showLoading = false;
        vm.validationErrors = [];
        vm.passwordRulesSatisfied = true;

        vm.toggleShowCurrentPwd = toggleShowCurrentPwd;
        vm.toggleShowNewPwd = toggleShowNewPwd;
        vm.toggleShowConfirmPwd = toggleShowConfirmPwd;
        vm.checkPasswordsMatch = checkPasswordsMatch;
        vm.passwordRulesValidated = passwordRulesValidated;
        vm.handleNewPwdChange = handleNewPwdChange;
        vm.handleConfirmPwdChange = handleConfirmPwdChange;
        vm.changePwdEnabled = changePwdEnabled;
        vm.cancel = cancel;
        vm.passwordHasMinLength = passwordHasMinLength;
        vm.passwordHasNumberOrSymbol = passwordHasNumberOrSymbol;

        vm.pwdValidationMessages = {
            PasswordRequiresDigit: "Please enter a password that contains at least one number (0-9)",
            PasswordRequiresSpecialCharacter: "Please enter a password that contains at least one special character (allowed: ! @ # $ % ^ & * ( ) _ + - = { } [ ] : ; \" ' < > , . ? / \\ | ~ `)",
            PasswordRequiresUpper: "Please enter a password that contains at least one uppercase letter (A-Z)",
            PasswordMustNotContainSpace: "Please enter a password that does not contain blank space",
            PasswordContainsInvalidChars: "Please enter a password that only contain English letters",
            PasswordMismatch: "Your current password is incorrect",
            PasswordTooShort: "Please enter a password that is at least 15 characters in length",
        };

        vm.pwdValidationOptions = {
            translations: zxcvbnts['language-en'].translations,
            graphs: zxcvbnts['language-common'].adjacencyGraphs,
            dictionary: {
                ...zxcvbnts['language-common'].dictionary,
                ...zxcvbnts['language-en'].dictionary,
            },
        };

        vm.strengthList = [
            { strength: "very-weak", displayText: "Very weak" },
            { strength: "weak", displayText: "Weak" },
            { strength: "so-so", displayText: "So-so" },
            { strength: "good", displayText: "Good" },
            { strength: "great", displayText: "Great" },
        ];

        vm.currentPwdStrength = vm.strengthList[0].strength;
        vm.message = vm.strengthList[0].displayText;
        vm.warning = '';
        vm.suggestion = '';

        getEmail();

        function handleNewPwdChange() {
            vm.warning = '';
            vm.suggestion = '';
            zxcvbnts.core.zxcvbnOptions.setOptions(vm.pwdValidationOptions);
            const validation = zxcvbnts.core.zxcvbn(vm.newPwd);
            const currentStrength = vm.strengthList[validation.score];
            vm.currentPwdStrength = currentStrength.strength;
            vm.message = currentStrength.displayText;
            vm.warning = validation.feedback.warning;
            if (vm.warning) {
                vm.suggestion = validation.feedback.suggestions.join(' ');
            }
            handleConfirmPwdChange();
        }

        function handleConfirmPwdChange() {
            vm.passwordsDontMatch = false;
            if (!!vm.newPwd && !!vm.confirmPwd && (vm.newPwd !== vm.confirmPwd)) {
                vm.passwordsDontMatch = true;
            }
        }

        function passwordRulesValidated() {
            var isValid = true;
            vm.passwordRulesSatisfied = true;
            if (vm.newPwd.length < 8 || vm.confirmPwd.length < 8) {
                vm.passwordRulesSatisfied = false;
                isValid = false;
            }
            return isValid;
        }

        function checkPasswordsMatch() {
            vm.passwordsDontMatch = false;
            vm.validated = false;
            vm.validationErrors = [];

            if (changePwdEnabled()) {
                changePassword();
            }
        }

        function changePassword() {
            var dataService = $http;
            vm.showLoading = true;
            const request = {
                UserName: vm.email,
                NewPassword: vm.newPwd,
                CurrentPassword: vm.currentPwd,
                PasswordResetToken: vm.ref
            };
            return dataService.post(urlHelper.getSuperbrandApiUrl() + "memberswebapi/password-resets", request)
                .then(function (_) {
                    sessionStorage.clear();
                    vm.success = true;
                },
                function (error) {
                    try {
                        if (error.status === 400 && error.data) {
                            vm.validationErrors = error.data.map(function (err) {
                                return {
                                    code: err.code,
                                    message: vm.pwdValidationMessages[err.code] ?? err.description,
                                };
                            });
                            if (error.data.some(function (err) { return err.code === 'InvalidToken'; })) {
                                vm.linkExpired = true;
                            }
                        } else {
                            vm.error = true;
                        }
                    } finally {
                        vm.validated = true;
                    }
                })
                .finally(function () {
                    vm.showLoading = false;
                });
        }

        function getEmail() {
            var sessionId = JSON.parse(sessionStorage.getItem("ngStorage-sessionId"));
            userService.getPolicyHolderBySessionId(sessionId)
                .then(function (result) {
                    if (Array.isArray(result == null ? void 0 : result.data) && result.data.length > 0) {
                        vm.email = result.data[0].emailAddress;
                    }
                });
        }

        function toggleShowCurrentPwd() {
            vm.showCurrentPwd = !vm.showCurrentPwd;
        }

        function toggleShowNewPwd() {
            vm.showNewPwd = !vm.showNewPwd;
        }

        function toggleShowConfirmPwd() {
            vm.showConfirmPwd = !vm.showConfirmPwd;
        }

        function changePwdEnabled() {
            return !!vm.newPwd && !!vm.confirmPwd &&
                vm.newPwd === vm.confirmPwd &&
                (vm.currentPwdStrength === vm.strengthList[3].strength || vm.currentPwdStrength === vm.strengthList[4].strength);
        }

        function passwordHasMinLength() {
            return !!vm.newPwd && vm.newPwd.length >= 15;
        }

        function passwordHasNumberOrSymbol() {
            return !!vm.newPwd && /[\d!@#$%^&*()_+\-={}[\]:;"'<>,.?/\\|~`]/.test(vm.newPwd);
        }

        function cancel() {
            window.history.back();
        }
    }
})();
